import configs from '../configs/environments';

interface ApiGateway {
  protocol: string;
  url: string;
  port: string;
  apiVersion: string;
}

const apiGateway: ApiGateway = configs.apiGateway;

export const baseUrl: string = `${apiGateway.protocol}://${apiGateway.url}:${apiGateway.port}/${apiGateway.apiVersion}/`;